import { Tabs } from "@mui/material";
import dayjs from "dayjs";
import { Bar, BarChart, ReferenceLine, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { info, secondary } from "../../../../theme/colors";
import { useState } from "react";
import CustomTooltip from "./CustomTooltip";
export var StartSlotsDate = dayjs().set('h', 0).set('minutes', 0).set('seconds', 0).set('milliseconds', 0);
var data = new Array(30).fill({}).map(function (it, i) { return ({
    index: i,
    TotalCount: Math.round(Math.random() * 20) + 30
}); });
export default function SlotSelector(props) {
    var _slot$index;
    var value = props.value, onChange = props.onChange, _a = props.name, name = _a === void 0 ? '' : _a;
    var slot = value === null || value === void 0 ? void 0 : value[name];
    var _b = useState(null), activeBarIndex = _b[0], setActiveBarIndex = _b[1];
    var renderTick = function (_ref) {
        var x = _ref.x, y = _ref.y, fontFamily = _ref.fontFamily, index = _ref.index;
        var currDate = StartSlotsDate.add(index + 1, 'days');
        var date = currDate.format('D');
        var day = currDate.format('ddd');
        return /*#__PURE__*/ React.createElement("g", {
            transform: "translate(".concat(x, ",").concat(y, ")"),
            fontFamily: fontFamily
        }, /*#__PURE__*/ React.createElement("text", {
            x: 0,
            y: 0,
            dy: 16,
            textAnchor: "middle",
            fill: secondary[500]
        }, date), /*#__PURE__*/ React.createElement("text", {
            x: 0,
            y: 20,
            dy: 16,
            textAnchor: "middle",
            fill: secondary[900]
        }, day));
    };
    var handleBarClick = function (data) {
        if (activeBarIndex === data.index) {
            setActiveBarIndex(null);
        }
        else {
            setActiveBarIndex(data.index);
        }
        onChange === null || onChange === void 0 || onChange(data, (slot === null || slot === void 0 ? void 0 : slot.index) === data.index ? undefined : data);
    };
    return /*#__PURE__*/ React.createElement(Tabs, {
        variant: "scrollable",
        scrollButtons: true,
        TabScrollButtonProps: {
            sx: {
                alignSelf: 'center',
                width: 'auto',
                p: 1,
                borderRadius: 2,
                background: secondary[50]
            }
        }
    }, /*#__PURE__*/ React.createElement(ResponsiveContainer, {
        height: 200,
        minWidth: data.length * 45
    }, /*#__PURE__*/ React.createElement(BarChart, {
        data: data,
        barGap: 10
    }, /*#__PURE__*/ React.createElement(XAxis, {
        height: 45,
        fontSize: 14,
        fontFamily: "NotoSans-SemiBold",
        tick: renderTick,
        tickLine: false,
        axisLine: {
            stroke: secondary[200],
            strokeWidth: 1
        }
    }), /*#__PURE__*/ React.createElement(YAxis, {
        domain: [0, 'dataMax + 20'],
        width: 0,
        tick: false,
        tickLine: false,
        axisLine: false
    }), /*#__PURE__*/ React.createElement(ReferenceLine, {
        x: 10,
        stroke: secondary[200],
        isFront: true,
        position: "start",
        label: {
            value: 'Feb',
            position: {
                x: 30,
                y: 20
            }
        }
    }), /*#__PURE__*/ React.createElement(ReferenceLine, {
        x: 0,
        stroke: secondary[200],
        isFront: true,
        position: "start",
        label: {
            value: 'Jan',
            position: {
                x: 30,
                y: 20
            }
        }
    }), /*#__PURE__*/ React.createElement(Bar, {
        dataKey: "TotalCount",
        fill: info[50],
        barSize: 35,
        cursor: "pointer",
        radius: [4, 4, 0, 0],
        onClick: function (data, i, e) { return handleBarClick(data); },
        activeIndex: (_slot$index = slot === null || slot === void 0 ? void 0 : slot.index) !== null && _slot$index !== void 0 ? _slot$index : -1,
        activeBar: {
            fill: info[500]
        }
    }))), activeBarIndex !== null && /*#__PURE__*/ React.createElement(CustomTooltip, {
        barIndex: activeBarIndex,
        barHeight: data[activeBarIndex].TotalCount * 2,
        tooltipValue: data[activeBarIndex].TotalCount
    }));
}
